import { Box } from '@mui/system';
import React from 'react';

const MarginBottomContainer = ({ children }) => {
    return (
        <Box sx={{ mb: 4 }}>
            {children}
        </Box>
    );
};

export default MarginBottomContainer;